import { Controller } from "stimulus";

export default class extends Controller {
  static values = { id: String };
  static targets = ["form"];

  connect() {
    this.isSubmitting = false;
    this.hasInitialized = false;

    const yearInput = this.element.querySelector("input[name*=\"created_at(1i)\"]");
    const monthInput = this.element.querySelector("input[name*=\"created_at(2i)\"]");
    const dayInput = this.element.querySelector("input[name*=\"created_at(3i)\"]");

    this.initialDate = {
      year: yearInput?.value,
      month: monthInput?.value,
      day: dayInput?.value
    };

    setTimeout(() => {
      this.hasInitialized = true;

      const dateInput = this.element.querySelector("input[type=\"text\"]");
      if (dateInput) {
        $(dateInput).on("change.datetimepicker", (e) => {
          setTimeout(() => {
            this.submitForm(e);
          }, 50);
        });
      }
    }, 200);
  }

  submitForm() {
    if (this.isSubmitting) {
      return;
    }

    if (!this.hasInitialized) {
      return;
    }

    const yearInput = this.element.querySelector("input[name*=\"created_at(1i)\"]");
    const monthInput = this.element.querySelector("input[name*=\"created_at(2i)\"]");
    const dayInput = this.element.querySelector("input[name*=\"created_at(3i)\"]");

    const currentDate = {
      year: yearInput?.value,
      month: monthInput?.value,
      day: dayInput?.value
    };

    if (this.initialDate.year === currentDate.year &&
        this.initialDate.month === currentDate.month &&
        this.initialDate.day === currentDate.day) {
      return;
    }

    this.isSubmitting = true;
    this.initialDate = currentDate;

    const form = this.element.querySelector("form");
    if (form) {
      $(form).submit();
    }
  }

  handleSuccess(event) {
    const [data] = event.detail;
    this.isSubmitting = false;

    if (data && data.message) {
      this.showFlashMessage(data.message, "success");
    }

    const inputGroup = this.element.querySelector(".input-group");
    if (inputGroup) {
      inputGroup.classList.add("border-success");
      inputGroup.style.borderWidth = "2px";
      inputGroup.style.borderStyle = "solid";
      setTimeout(() => {
        inputGroup.classList.remove("border-success");
        inputGroup.style.borderWidth = "";
        inputGroup.style.borderStyle = "";
      }, 1500);
    }
  }

  showFlashMessage(message, type = "success") {
    let flashContainer = document.querySelector(".flash-messages");
    if (!flashContainer) {
      flashContainer = document.createElement("div");
      flashContainer.className = "flash-messages";
      flashContainer.style.cssText = "position: fixed; top: 20px; right: 20px; z-index: 9999;";
      document.body.appendChild(flashContainer);
    }

    const flash = document.createElement("div");
    flash.className = `alert alert-${type} alert-dismissible fade show`;
    flash.style.cssText = "min-width: 300px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);";
    flash.innerHTML = `
      ${message}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    `;

    flashContainer.appendChild(flash);

    setTimeout(() => {
      $(flash).fadeOut(300, function() {
        flash.remove();
      });
    }, 5000);
  }

  handleError(event) {
    this.isSubmitting = false;

    const [data] = event.detail;
    const errorMessage = data?.message || "Error updating date";
    alert(errorMessage);
  }

  disconnect() {
    const dateInput = this.element.querySelector("input[type=\"text\"]");
    if (dateInput) {
      $(dateInput).off("change.datetimepicker");
    }
    this.isSubmitting = false;
    this.hasInitialized = false;
  }
}
